import { FC, useRef, useState } from 'react';
import { classes } from './AccountButton.st.css';
import accountCircleLogo from 'src/redesign/assets/accountCircle.svg';
import chevronDownIcon from 'src/redesign/assets/chevronDown.svg';
import { OverlayPanel, OverlayPanelPassThroughOptions } from 'primereact/overlaypanel';
import { TieredMenu, TieredMenuPassThroughOptions } from 'primereact/tieredmenu';
import { MenuItem } from 'primereact/menuitem';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { Avatar } from 'primereact/avatar';
import c from 'clsx';
import { AccountSettingsModal } from 'src/redesign/features/Modals/AccountSettingsModal';
import { accountSelector } from 'src/redesign/features/Account/store/selectors';
import { logoutAccount } from 'src/redesign/features/Account/store/actions';

const AccountInfo: FC = () => {
  const account = useAppSelector(accountSelector);

  return (
    <div className={classes.accountInfoContainer}>
      <Avatar
        className={classes.avatar}
        label={account?.first_name?.charAt(0).toUpperCase()}
        size="xlarge"
        shape="circle"
      />
      <div className={classes.accountInfoText}>
        <span className={classes.accountName}>
          {account.first_name} {account.last_name}
        </span>
        <span className={classes.accountEmail}>{account.email}</span>
      </div>
    </div>
  );
};

export const AccountButton: FC = () => {
  const accountOverlayRef = useRef<OverlayPanel>();
  const dispatch = useAppDispatch();
  const [visible, setVisible] = useState(false);

  const items: MenuItem[] = [
    {
      template: <AccountInfo />,
      className: classes.avatarCustomLabelWrapper,
    },
    {
      separator: true,
    },
    {
      label: 'Account Setting',
      className: classes.menuItemLink,
      icon: 'pi pi-cog',
      command: () => {
        setVisible(true);
      },
    },
    {
      label: 'Logout',
      className: c(classes.menuItemLink, classes.menuItemLogout),
      icon: 'pi pi-sign-out',
      command: () => dispatch(logoutAccount()),
    },
  ];

  const overlayPtOptions: OverlayPanelPassThroughOptions = {
    root: {
      className: classes.ptOverlay,
    },
    content: {
      style: {
        padding: '0',
      },
    },
  };

  const menuItemPtOption: TieredMenuPassThroughOptions = {
    separator: {
      style: {
        margin: '8px 0',
        borderColor: '#D9D9D9',
      },
    },
    menuitem: {
      className: classes.menuItem,
    },
    label: {
      style: {
        width: '100%',
      },
    },
    root: {
      style: {
        width: '100%',
        border: 'none',
        borderRadius: '16px',
      },
    },
  };

  return (
    <>
      <button onClick={(e) => accountOverlayRef.current.toggle(e)} className={classes.button}>
        <img className={classes.logo} src={accountCircleLogo} alt="account" />
        Account
        <img src={chevronDownIcon} alt="down" />
      </button>
      <OverlayPanel pt={overlayPtOptions} className={classes.overlay} ref={accountOverlayRef}>
        <TieredMenu pt={menuItemPtOption} className={classes.styledTieredMenu} model={items} />
      </OverlayPanel>
      <AccountSettingsModal isVisible={visible} setVisible={(value) => setVisible(value)} />
    </>
  );
};
